export class ProgressItem {

  progressItem: HTMLElement | null
  remaining: HTMLElement | null
  input: HTMLProgressElement | null

  constructor(progressItem: HTMLElement | null) {
    this.progressItem = progressItem
    this.remaining = progressItem?.querySelector(".i-progress__remaining") ?? null
    this.input = progressItem?.querySelector(".i-progress__input") ?? null
  }

  setRemaining(remaining: string) {
    if (!this.remaining) return
    this.remaining.innerHTML = remaining
    this.progressItem.classList.toggle("--filled", parseFloat(remaining) <= 0)
  }

  setPercentage(percentage: number) {
    if (!this.input) return
    this.input.value = percentage
  }

  setProgress(remaining: string, percentage: number) {
    this.setRemaining(remaining)
    this.setPercentage(percentage)
  }
}

export const rerenderProgresses = (remaining, percentage) => {
  const progresses = document.querySelectorAll<HTMLElement>('.i-progress');
  progresses.forEach(item => {
    const progress = new ProgressItem(item);
    progress.setProgress(remaining, percentage);
  })
}
